import * as React from 'react';
import {withTranslation, WithTranslation} from 'react-i18next';

import * as styles from './cardFull.module.scss';

export interface CardFullProps extends WithTranslation<'Card'> {
  category?: string;
  categoryUrl?: string;
  heading: string;
  text: string;
  linkUrl: string;
  linkLabel?: string;
  backgroundImageUrl?: string;
}

const CardFull = ({
  category,
  categoryUrl,
  heading,
  text,
  linkUrl,
  linkLabel,
  backgroundImageUrl,
  t,
}: CardFullProps) => {
  const divStyle: React.CSSProperties = backgroundImageUrl && {
    // stylelint-disable
    backgroundImage: `url('${backgroundImageUrl}')`,
  };

  return (
    <figure className={styles.wrapper}>
      <a className={styles.link} href={linkUrl}>
        <div className={styles.inner}>
          {divStyle && <div style={divStyle} className={styles.bgImg} />}
          <div className={styles.content}>
            {category && categoryUrl && (
              <div className={styles.categoryLinkWrapper}>
                <a className={styles.categoryLink} href={categoryUrl}>
                  <h4 className={styles.category}>{category}</h4>
                </a>
              </div>
            )}
            <h2 className={styles.heading}>{heading}</h2>
            <p className={styles.text}>{text}</p>
            <div className={styles.linkWrapper}>
              <span className={styles.linkLabel}>
                {linkLabel || t('readMoreLabel')}
              </span>
            </div>
          </div>
        </div>
      </a>
    </figure>
  );
};

export default withTranslation('Card')(CardFull);
